import { gql } from "apollo-boost";

const VIEWER_QUERY = gql`
  query viewerQuery {
    viewer {
      email
    }
  }
`;

export default VIEWER_QUERY;
